// lib/directory/resultsSession.ts

export type DirectoryFilters = {
  search: string;
  activeCategory: string;
  selectedCityId: string | null;
  selectedAreaId: string | null;
};

export type DirectoryResultsSession = {
  slugs: string[];
  selectedIndex: number;
  scrollOffsetY: number;
  filters: DirectoryFilters;
  updatedAt: number;
};

let currentDirectoryResultsSession: DirectoryResultsSession | null = null;

export function setDirectoryResultsSession(
  session: DirectoryResultsSession | null
) {
  currentDirectoryResultsSession = session;
}

export function getDirectoryResultsSession(): DirectoryResultsSession | null {
  return currentDirectoryResultsSession;
}

export function updateDirectoryResultsSelectedIndex(selectedIndex: number) {
  if (!currentDirectoryResultsSession) return;

  currentDirectoryResultsSession = {
    ...currentDirectoryResultsSession,
    selectedIndex,
    updatedAt: Date.now(),
  };
}

export function updateDirectoryResultsScrollOffset(scrollOffsetY: number) {
  if (!currentDirectoryResultsSession) return;

  currentDirectoryResultsSession = {
    ...currentDirectoryResultsSession,
    scrollOffsetY,
    updatedAt: Date.now(),
  };
}

export function clearDirectoryResultsSession() {
  currentDirectoryResultsSession = null;
}